import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import brokersAxios from '../../../../utils/axios/brokers-roles.axios';
import { ApiResponse } from '../../../../interfaces/models/models/paginated-response.model';


const tryToFetchIntegrationsWithPagination = (
    pageNumber: number,
    pageSize: number,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${USERS_API_URL}/user-integration-data/all?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/user-integration-data/all?page=${pageNumber}&size=${pageSize}`;
    return brokersAxios.get<any>(url);
};

const tryToFetchAllPartnerIntegrations = (): Promise<AxiosResponse> => {
    return brokersAxios.get(`${USERS_API_URL}/user-integration-data/all`);
};

const tryToAddIntegration = (data: any): Promise<AxiosResponse> => {
    return brokersAxios.post(`${USERS_API_URL}/user-integration-data`, data);
};

const tryToEditIntegration = (id: string, data: any): Promise<AxiosResponse> => {
    return brokersAxios.put(`${USERS_API_URL}/user-integration-data/${id}`, data);
};

const tryToFetchSingleIntegration = (id: string): Promise<AxiosResponse<ApiResponse<any>>> => {
    return brokersAxios.get<ApiResponse<any>>(`${USERS_API_URL}/user-integration-data/${id}`);
};

const tryToDeleteIntegration = (id: string): Promise<AxiosResponse> => {
    return brokersAxios.delete(`${USERS_API_URL}/user-integration-data/${id}/hotel`);
};

export const IntegrationsService = {
    tryToFetchIntegrationsWithPagination,
    tryToFetchAllPartnerIntegrations,
    tryToAddIntegration,
    tryToEditIntegration,
    tryToDeleteIntegration,
    tryToFetchSingleIntegration
};